import { ConfirmDialog, notify } from "@/components/kit";
import { useDeleteSeoSlug } from "@/hooks/api/seo-slug/useDeleteSeoSlug";
import { SeoSlug } from "@/types/seo-slug";

interface SeoSlugDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  seoSlug?: SeoSlug;
}

const SeoSlugDeleteModal = ({
  isOpen,
  onClose,
  seoSlug,
}: SeoSlugDeleteModalProps) => {
  const { mutate: deleteSeoSlug, isPending: isDeletingSeoSlug } =
    useDeleteSeoSlug();
  const handleDelete = () => {
    deleteSeoSlug(seoSlug!.id, {
      onSuccess: () => {
        onClose();
        notify.success("SEO slug deleted successfully");
      },
      onError: (error) => {
        console.error(error);
        notify.error("Failed to delete SEO slug", "Please try again");
      },
    });
  };

  return (
    <ConfirmDialog
      confirmLabel="Delete"
      isOpen={isOpen}
      isPending={isDeletingSeoSlug}
      title="Delete SEO Slug"
      onClose={onClose}
      onConfirm={handleDelete}
    >
      <p className="text-sm">
        You're about to delete SEO slug "
        <span className="font-semibold">{seoSlug?.slug}</span>"
      </p>
      <p className="text-muted mt-1 text-sm">This action cannot be undone.</p>
    </ConfirmDialog>
  );
};

export default SeoSlugDeleteModal;
